import * as React from "react";
import Dialog from "@mui/material/Dialog";
import { Stack } from "@mui/system";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Button, Grid, Typography } from '@mui/material';
import { MobileDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import './DialogElements.css'
import { APPLY_BUTTON_TEXT } from '../../constants.js';
import { colourOptions } from "./Options";
import Select from "react-select";
import moment from "moment";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

export const SimpleDialog = (props,) => {
    const { onClose, selectedValue, open,
        filterData, selected, setExpEndDate,
        setFilterData,handleSelectChange,chipsState
        
    } = props;

    const dispatch = useDispatch();
   
  
    const dateValue = (date) => {
      if (date) {
        return moment.utc(date).local().format("yyyy/MM/DD");
      } else {
        return "";
      }
    };
  
    const dispatchNotification = (typ, msg) => {
      dispatch({
        type: "SHOW_NOTIFICATION",
        data: {
          open: true,
          type: typ,
          message: msg,
        },
      });
    };
  
    const handleApply = () => {
      
      if(filterDataDate.mnfStartDate > filterDataDate.mnfEndDate && filterDataDate.mnfEndDate!==null){
          dispatchNotification("error", ["Manufacturing Start Date cannot be less than End Date"]);
      }
      else if(filterDataDate.expStartDate > filterDataDate.expEndDate && filterDataDate.expEndDate!==null){
          dispatchNotification("error", ["Expiry Start Date cannot be less than End Date"]);
      }
      else{
          onClose(selectedValue);
          setFilters();
      }
      
    };
    const handleClear = () => {
      
  
      setFilterDataDate({
        expStartDate: "",
        expEndDate: "",
        mnfEndDate: "",
        mnfStartDate: "",
      });
    };
  
    const filterDataRedux = useSelector((state) => state.filterData);
  
  
  
  
    const [filterDataDate, setFilterDataDate] = React.useState({
      expStartDate: filterDataRedux.searchCriteriaList[2]?.value
        ? Date.parse(filterDataRedux.searchCriteriaList[2]?.value?.split("-")[0])
        : null,
      expEndDate: filterDataRedux.searchCriteriaList[2]?.value
        ? Date.parse(filterDataRedux.searchCriteriaList[2]?.value?.split("-")[1])
        : null,
      mnfEndDate: filterDataRedux.searchCriteriaList[1]?.value
        ? Date.parse(filterDataRedux.searchCriteriaList[1]?.value?.split("-")[1])
        : null,
      mnfStartDate: filterDataRedux.searchCriteriaList[1]?.value
        ? Date.parse(filterDataRedux.searchCriteriaList[1]?.value?.split("-")[0])
        : null,
    });
  
  
  
   
  
    const setFilters = () => {
  
      var json = filterDataRedux.searchCriteriaList;
  
      var json1 = structuredClone(json);
  
  
      
  
      json1[1].value = `${dateValue(
        filterDataDate.mnfStartDate
      )}${"-"}${dateValue(filterDataDate.mnfEndDate)}`;
      json1[2].value = `${dateValue(
        filterDataDate.expStartDate
      )}${"-"}${dateValue(filterDataDate.expEndDate)}`;
      dispatch({
        type: "UPDATE_FILTER",
        data: json1,
      });
    };

    return (
        <Dialog onClose={onClose} open={open} PaperProps={{
            sx: {
                width: "auto",
                height: 300,
            }
        }} >
            <Typography p={1} ml="auto" mr="auto" sx={{ alignItems: "center" }}>Select Filter</Typography>
            <CloseIcon onClick={onClose} sx={{ marginRight: "16px" }} />
            <Stack direction="column" spacing={2} sx={{ marginRight: "2rem", marginLeft: "2rem" }}>

                <Box>
                    <Typography>
                        Sample Sent Date
                    </Typography>
                    <Grid container md={12} spacing={1}  >
                        <Grid item md={6} xs={12} sm={12} >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileDatePicker
                                 value={filterDataDate.mnfStartDate}
                                 label="Start Date"
                                 inputFormat="DD/MM/YYYY"
                                 renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, readOnly: true}} />}
                                 onChange={(date) =>
                                     setFilterDataDate({
                                    ...filterDataDate,
                                      mnfStartDate: date?.$d,
                                     })
                                 }
                                  className="input-date-picker"
                                 sx={{ mb: "1", mt: "1" }}
                                 />
                        </LocalizationProvider>
                            {/* <DatePicker
                                wrapperClassName="datePicker"
                                dateFormat="dd/MM/yyyy"
                                selected={filterData.recStartDate}
                                onChange={(date) => setFilterData({ ...filterData, "recStartDate": date })}
                                placeholderText="Start Date"
                            /> */}
                        </Grid>
                        <Grid item md={6} xs={12} sm={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  value={filterDataDate.mnfEndDate}
                  label="End Date"
                  className="input-date-picker"
                  inputFormat="DD/MM/YYYY"
                  renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, readOnly: true}}/>}
                  onChange={(date) =>
                    setFilterDataDate({
                      ...filterDataDate,
                      mnfEndDate: date?.$d,
                    })
                  }
                  sx={{ mb: "1" }}
                />
              </LocalizationProvider>
                            {/* <DatePicker
                                selected={filterData.recEndDate}
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => setFilterData({ ...filterData, "recEndDate": date })}
                                placeholderText="End Date" /> */}
                        </Grid>
                    </Grid>
                </Box>
                <Box>
                    <Typography>
                        Received Date
                    </Typography>
                    <Grid container md={12} spacing={1}>
                        <Grid item md={6} xs={12} sm={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  value={filterDataDate.expStartDate}
                  label="Start Date"
                  className="input-date-picker"
                  inputFormat="DD/MM/YYYY"
                  renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, readOnly: true}}/>}
                  onChange={(date) =>
                    setFilterDataDate({
                      ...filterDataDate,
                      expStartDate: date?.$d,
                    })
                  }
                  sx={{ mb: "1" }}
                />
              </LocalizationProvider>
                            {/* <DatePicker
                                selected={filterData.sentStartDate}
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => setFilterData({ ...filterData, "sentStartDate": date })}
                                placeholderText="Start Date"
                                sx={{ mb: "1" }} /> */}
                        </Grid>
                        <Grid item md={6} xs={12} sm={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  value={filterDataDate.expEndDate}
                  label="End Date"
                  inputFormat="DD/MM/YYYY"
                  className="input-date-picker"
                  renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, readOnly: true}}/>}
                  onChange={(date) =>
                    setFilterDataDate({
                      ...filterDataDate,
                      expEndDate: date?.$d,
                    })
                  }
                  sx={{ mb: "1" }}
                />
              </LocalizationProvider>
                            {/* <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={filterData.sentStartDate}
                                onChange={(date) => setFilterData({ ...filterData, "sentStartDate": date })}
                                placeholderText="End Date" /> */}
                        </Grid>
                    </Grid>
                </Box>
               

<Stack direction="row" justifyContent={"space-between"} spacing={2}
        sx={{ marginRight: "2rem", marginLeft: "2rem" }}>

        <Button onClick={handleClear} sx={{ width: "49%" }} variant="contained">
          Clear
        </Button>
        <Button onClick={handleApply} sx={{ width: "49%" }} variant="contained">
          Apply
        </Button>

      </Stack>
            </Stack>

    </Dialog>
  );
};
